


















import { defineComponent } from '@vue/composition-api';
import { showDialog, hideDialog } from '@tencent/wphk-components-dialog';
import { i18n } from '@/i18n';
import { useSearchHistory } from './use-search-history';

export default defineComponent({
  emits: ['search'],
  setup(props, { emit }) {
    // const list = ref(['大', '麦当劳', '星巴克', '星', '谭仔三哥', '麦当劳', '星巴克', '谭仔三哥', '谭仔', '星', 'sam gor']);
    const { getHistory, setHistory, clearHistory } = useSearchHistory();
    const list = getHistory();

    function eClickDelete() {
      showDialog({
        content: i18n('確認刪除全部歷史搜索記錄？'),
        btns: [{
          text: i18n('取消'),
          click: () => {
            hideDialog();
          },
        }, {
          text: i18n('確認'),
          click: () => {
            clearHistory();
            hideDialog();
          },
        }],
      });
    }
    /** 点击某个选项 */
    function eClickItem(item: string) {
      emit('search', item);
      setHistory(item);
    }

    return {
      list,

      eClickDelete,
      eClickItem,
    };
  },
});

